$(document).ready(function(){
  let searchPostCode = document.getElementById('search_postcode');
  if (searchPostCode) {
    searchPostCode.innerText = 'check';
  }
  $('.complimentary-img-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: "<a href='#' class='slick-arrow-left'></a>",
    nextArrow: "<a href='#' class='slick-arrow-right'></a>",
    arrow: false,
    responsive: [
      {
        breakpoint: 981,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.vsc_img_slider_2').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    prevArrow: "<a href='#' class='slick-arrow-left'></a>",
    nextArrow: "<a href='#' class='slick-arrow-right'></a>",
    arrow: false,
    responsive: [
      {
        breakpoint: 981,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.article-list-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrow: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.tab-container .tab-item ul li').click(function(){
    var tab_id = $(this).attr('data-tab');
    var tab_location = $(this).find('a').html().toLowerCase();

    $('.tab-container .tab-item ul li').removeClass('active');
    $('.tab-content-wraper .tab-content').removeClass('active');

    $(this).addClass('active');
    $("."+tab_id).addClass('active');
    var currentUrlwithLocation = location.protocol + '//' + location.host + location.pathname + "#" + tab_location;
    history.pushState({tab: tab_location},"",currentUrlwithLocation);
  });
  $(".section-featured-blog #custom-slick-prev").on("click", function(){
    $('.slick-prev').trigger('click');
  });
  $(".section-featured-blog #custom-slick-next").on("click", function(){
    $('.slick-next').trigger('click');
  });
  $(document).on('click', '.product-view-container .product-view-btn', function(){
    var btnView = $(this).attr('data-toggle');
    var targetKiller = `product-list--per-row-1 product-list--per-row-2 product-list--per-row-3 product-list--per-row-4 product-list--per-row-5`;
    var targetEle = $('.collection-listing .product-list');
    $(targetEle).removeClass(targetKiller).addClass(`product-list--per-row-${btnView}`);
    $(this).addClass('active').siblings().removeClass('active');
  });
  $('.pdp-bottom-gallary .product-tiles-row').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 3,
    prevArrow: '<button type="button" class="image-page-button image-page-button--previous" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + '</button>',
    nextArrow: '<button type="button" class="image-page-button image-page-button--next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + '</button>',
    arrow: false
  })

  // new rebuy layout design
  setInterval(() => {
    $('.rebuy-product-options').each(function(){
      let infoDiv = $(this).siblings('.rebuy-product-info');
      $(this).appendTo(infoDiv)
    })
  }, 10);
  // pdp accordions
  $('.metafield-accordian .cc-accordion-item').click(function(){
    $(this).siblings().removeAttr('open').removeClass('is-open');
  })


  // pdp metafield swatch & related-product slider
  $('.pdp-metafield-block-slider .cc-accordion-item__content.rte').slick({
    loop:true,
    dots:true,
    arrow: true,
    slidesToShow:4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      }
    ]
  });
  $(document).on('click','.cc-accordion-item',function(){
    $('.pdp-metafield-block-slider .cc-accordion-item__content.rte').slick('refresh');
    let metaPdpBlockDots = document.querySelectorAll('.product-detail .pdp-metafield-block-slider .slick-dots li');
    if (metaPdpBlockDots.length == 1) {
      let metaPdpBlockDotsParent = document.querySelector('.product-detail .pdp-metafield-block-slider .slick-dots');
      metaPdpBlockDotsParent.style.display = 'none';
    }
  });
  // metafield gallery slider
  if(window.innerWidth <= 767){
    $('.pdp-meta-img-text-section .rimage-outer-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrow: true,
      adaptiveHeight: true,
      fade:true
    });
    $('.pdp-meta-img-text-section .rimage-outer-wrapper').slick('slickUnfilter');
    $('.pdp-meta-img-text-section .rimage-outer-wrapper').slick('slickFilter',':not(.product-img)');

    $('.section-footer__menu-block .section-footer__menu-block__menu').hide();
    $('.section-footer__title').click(function(){
      $(this).toggleClass('active').siblings('.section-footer__menu-block__menu').slideToggle(250);
    });
  }


  function resizeDebounce(func, wait = 200, immediate = true) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  function offTooltipETAEvents() {
    if($('.price-sku-inline .tooltip-ETA').length < 1){
      $('.tooltip-ETA').removeClass('open is-opening is-closing');
      $('.tooltip-ETA').first().css('height','').appendTo('.price-sku-inline .product-inventory-notice');
    }
    $('.price-sku-inline').next('.tooltip-ETA').remove();
    $('.product-form').off('click', '.product-info-block.product-inventory-notice');
    $('.product-form').off('transitionend', '.product-info-block.product-inventory-notice .tooltip-ETA');
  }

  function addTooltipETAEvents() {
    if(window.innerWidth > 767){
      $('.tooltip-ETA').removeClass('open is-opening is-closing').css('height', '');
      if($('.price-sku-inline').next('.tooltip-ETA').length < 1){
        $('.price-sku-inline .tooltip-ETA').insertAfter('.price-sku-inline');
      }
    }else{
      if($('.price-sku-inline').next('.tooltip-ETA').length > 0 && $('.price-sku-inline .tooltip-ETA').length < 1){
        $('.price-sku-inline').next('.tooltip-ETA').appendTo('.price-sku-inline .product-inventory-notice');
      }else if($('.tooltip-ETA').length > 1){
        $('.price-sku-inline').next('.tooltip-ETA').remove();
      }
      $('.tooltip-ETA').removeClass('open is-opening is-closing').css('height', '');
    }
    $('.product-form').on('click', '.product-info-block.product-inventory-notice', function () {
      let $eta_tooltip = (window.innerWidth <= 767 ) ? $(this).find('.tooltip-ETA') : $('.price-sku-inline').next('.tooltip-ETA');
      if ($eta_tooltip.length > 0) {

        if ($eta_tooltip.hasClass('is-opening') || $eta_tooltip.hasClass('is-closing')) {
          return;
        }

        if (!$eta_tooltip.hasClass('open')) {
          $eta_tooltip.addClass('is-opening open');
          $eta_tooltip.css('height', $eta_tooltip[0].scrollHeight + 'px');
        } else {
          $eta_tooltip.addClass('is-closing');
          $eta_tooltip.removeClass('open').css('height', 0);
        }

      }
    });

    $('.product-form').on('transitionend', '.tooltip-ETA', function (e) {
      let $eta_tooltip = $(this);
      let ePropertyName = e.originalEvent?.propertyName || e.nativeEvent?.propertyName;
      if (e.target === $eta_tooltip[0] && ePropertyName === 'height') {
        $eta_tooltip.removeClass('is-opening is-closing');
      }
    });
  };

  function initialInventoryNoticeMobile(){
    let $inventory = $('.price-sku-inline .variant-visibility-area');
    if($inventory.length > 0){
        let inventoryHtml = $inventory.html();
        let $targetinventoryHtml = $('.lightly-spaced-row.mobile-position.insertAfter-atc');
        $targetinventoryHtml.html(inventoryHtml);
    }
  }

  function offInventoryNoticeMobile(){
    $('.insertAfter-atc').empty();
  }

  //detect window resize
  var cachedWidth = $(window).width;
  $(window).on('resize', resizeDebounce(function() {
    var currentWidth = $(window).width();
      if (currentWidth !== cachedWidth && window.innerWidth <= 767) {
        if($('.pdp-meta-img-text-section .rimage-outer-wrapper .slick-current').length < 1){
          $('.pdp-meta-img-text-section .rimage-outer-wrapper').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrow: true,
            adaptiveHeight: true,
            fade:true
          });
          $('.pdp-meta-img-text-section .rimage-outer-wrapper').slick('slickUnfilter');
          $('.pdp-meta-img-text-section .rimage-outer-wrapper').slick('slickFilter',':not(.product-img)');
        }

        $('.section-footer__menu-block .section-footer__menu-block__menu').hide();
        $('.section-footer__title').unbind('click').click(function(){
          $(this).toggleClass('active').siblings('.section-footer__menu-block__menu').slideToggle(250);
        });

        if($('.tooltip-ETA').length > 0){
          addTooltipETAEvents();
        }
        if(!window.matchMedia('(hover: hover)').matches && ($('.tooltip-mobile img').length > 0 || $('.tooltip-mobile').css('background-color') != "rgba(0, 0, 0, 0)")){
          var currentTooltipHeight = $('.tooltip-mobile').css('width');
          $('.tooltip-mobile').css('height', currentTooltipHeight);
        }
        initialInventoryNoticeMobile();

      } else if(currentWidth !== cachedWidth && window.innerWidth > 767){
          $('.pdp-meta-img-text-section .rimage-outer-wrapper').slick('unslick');

          $('.section-footer__menu-block .section-footer__menu-block__menu').each(function(){
            if($(this).css('display')=='none') {
              $(this).css('display','');
            }
          })
          $('.section-footer__title').each(function(){
            if($(this).hasClass('active')) {
              $(this).removeClass('active');
            }
          })

          if (window.matchMedia('(hover: hover)').matches && $('.tooltip-ETA').length > 0) {
            offTooltipETAEvents();
          }else if($('.tooltip-ETA').length > 0){
            addTooltipETAEvents();
          }
          if((!window.matchMedia('(hover: hover)').matches) && ($('.tooltip-mobile img').length > 0 || $('.tooltip-mobile').css('background-color') != "rgba(0, 0, 0, 0)")){
            var currentTooltipHeight = $('.tooltip-mobile').css('width');
            $('.tooltip-mobile').css('height', currentTooltipHeight);
          }
          offInventoryNoticeMobile();

      }
      cachedWidth = currentWidth;
  }, 200));

  // trigger second add to cart button
  $(document).on('click','#second-atc', function(){
    $('#first-atc').trigger('click');
  });
  function insertAfter(newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
  }
  // PDP pre order app UX
  if (__st.p == 'product') {
  const swatchBtn = document.querySelectorAll('.opt-label');
  swatchBtn.forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout( () => {
        let quantityWrapper = document.querySelector('.quantity-submit-row');
        let inventoryLevel = document.querySelector('.price-sku-inline .variant-visibility-area');
        let topMsg = document.querySelector('.gPreorderTopMessage');
        let botMsg = document.querySelector('.gPreorderBottomMessage');
        if (botMsg) {
          insertAfter(botMsg,quantityWrapper)
        }
        if (topMsg) {
          inventoryLevel.appendChild(topMsg);
        }
      if(window.innerWidth <= 767){
      	if (topMsg) {
          insertAfter(topMsg,quantityWrapper)
        }
      }
      },1000)
    })
  });
}

  $('.swatch-option-item input:checked').trigger('click');
  if (window.innerWidth <= 767) {
      $('#rebuy-widget-23815').hide();
  }

  // pdp metafield section with image
  if (window.innerWidth <= 767) {
    let pdp_accordion = document.querySelector('#product-info');
    if(pdp_accordion !== null){
      pdp_accordion.classList.remove('is-open');
      pdp_accordion.removeAttribute("open");
    }
  }

	//click opt-label, show colour value label, show the tooltip on mobile
	if($(".option-type-colour .js-option").is(":checked")){
    jQuery('<div>', {
              class: 'tooltip-mobile'
          }).insertBefore(".option-type-colour");

      $(".option-type-colour").on("click",".opt-label",function(){
          if((!window.matchMedia('(hover: hover)').matches) || window.innerWidth <= 767){
            $(".tooltip-mobile").empty();
            $(".tooltip-mobile").removeAttr("style");
            var tooltip_background = $(this).find(".tooltip-wrapper .tooltip-hex").css("background-color");
            var tooltip = $(this).find(".tooltip-wrapper img").clone();
            tooltip.appendTo(".tooltip-mobile");
            var currentTooltipHeight = ($('.tooltip-mobile img')[0]) ? $('.tooltip-mobile img')[0].scrollHeight : null;
            if(tooltip_background){
              currentTooltipHeight = $('.tooltip-mobile').css('width');
              $('.tooltip-mobile').css({"background-color":tooltip_background, "height": currentTooltipHeight});
            }else if(currentTooltipHeight){
              $('.tooltip-mobile').css({"background-color":tooltip_background, "height": currentTooltipHeight});
            }
          }
      });
    };


    if ((!window.matchMedia('(hover: hover)').matches) || window.innerWidth <= 767) {
      addTooltipETAEvents();
    }



    $('.hotspot-label').click(function(event) {
      $(this).next('.hotspot-tooltip').toggleClass('visible');
      var targetProductLink = $(this).parent().find('.hotspot-tooltip a').attr('href');
      window.open(targetProductLink, '_blank');
    });

    $('div:has(.product-hotspot) img').on('click', function() {
      var parentContainer = $(this).closest('div');
      var tooltipVisibleCount = parentContainer.find('.hotspot-tooltip.visible').length;
      var tooltipCount = parentContainer.find('.hotspot-tooltip').length;
      if(tooltipVisibleCount != tooltipCount){
        parentContainer.find('.hotspot-tooltip').removeClass('visible');
        parentContainer.find('.hotspot-tooltip').toggleClass('visible');
      }else{
        parentContainer.find('.hotspot-tooltip').toggleClass('visible');
      }
    });

        $('.image-slider-inner').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 1500,
          arrow: true,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 981,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });

 

        if($('.image-slider-withLinks-inner').length > 0) {
          const desktopSlides = parseInt($('.image-slider-withLinks-inner').data('perrow'));
          $('.image-slider-withLinks-inner').slick({
            slidesToShow: desktopSlides,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            arrow: false,
            prevArrow: '<button type="button" class="image-page-button image-page-button--previous logo-slider-button" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + '</button>',
            nextArrow: '<button type="button" class="image-page-button image-page-button--next logo-slider-button" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + '</button>',
            adaptiveHeight: true,
            responsive: [
              {
                breakpoint: 769,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
          });
        }

        $('.logo-list-slider .logo-list-row').slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3000,
          arrow: false,
          prevArrow: '<button type="button" class="image-page-button image-page-button--previous logo-slider-button" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + '</button>',
          nextArrow: '<button type="button" class="image-page-button image-page-button--next logo-slider-button" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + '</button>',
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 981,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });

        $('.section-featured-blog-blocks .atricle-list-slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 1500,
          arrow: true,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 981,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });

    function checkSlideShowInViewport() {
        $('.section-slideshow .slideshow').each(function() {
            var $slideEl = $(this);
            var windowHeight = $(window).height();
            var scrollTops = $(window).scrollTop();
            var slideOffsetTop = $slideEl.offset().top;

            if (!$slideEl.hasClass('in-viewport') && slideOffsetTop < scrollTops + windowHeight && slideOffsetTop + $slideEl.height() > scrollTops) {
                $slideEl.addClass('in-viewport');
                $slideEl.slick('slickGoTo', 0);
            }
        });
    };
    checkSlideShowInViewport();

    //back-to-top button on collection page & main product page
    var backToTop = $('.icon.icon-tabler.icon-tabler-chevrons-up');
    $(window).scroll(function(){
        if(window.location.href.indexOf("products") > -1) {
          if( window.innerWidth > 767 ) {
              if ($(window).scrollTop() > 1106 ) {
                backToTop.addClass('show');
              } else {
                backToTop.removeClass('show');
              }
          } else {
            if ($(window).scrollTop() > 1374 ) {
              backToTop.addClass('show');
            } else {
              backToTop.removeClass('show');
            }
          }
        } else {
          if (($(window).scrollTop() > 3055) && window.innerWidth > 767 ) {
            backToTop.addClass('show');
          } else {
            backToTop.removeClass('show');
          }
        }

        if ($('.section-slideshow .slideshow') && !($('.section-slideshow .slideshow').hasClass('in-viewport'))) {
            checkSlideShowInViewport();
        }
    })

    backToTop.on('click', function(e) {
      e.preventDefault();
      if(window.location.href.indexOf("products") > -1) {
        if( window.innerWidth > 767 ) {
          $('html, body').animate({scrollTop:0}, '1004');
        } else {
          $('html, body').animate({scrollTop:0}, '1374');
        }
      } else {
        $('html, body').animate({scrollTop:0}, '3055');
      }

    });

    //scroll-down arrows below background-video section
    var downTonextSection = $('.scroll-down-arrows');
    downTonextSection.on('click', function(e) {
      e.preventDefault();
      $nextSection = $(this).closest(".shopify-section").next();
      var scrollPosition = $nextSection.offset().top - parseInt($(this).closest('body').find('#shopify-section-header').css('height'));
      $('html, body').animate({scrollTop: scrollPosition, behavior: 'smooth'});
    });


    //quick-addon-block-event
    $('.quick-addon-product-block #buyTogether').on('click', function() {
        if ($(this).is(':checked')) {
          const selectedAddonVariantId = $(this).closest('.quick-addon-product-block').find('select#addon-product-variantsOptions').val();
          const selectedAddonVariantQty = $(this).closest('.product-purchase-form').find('input#quantity').val();
          const addonVariantObj = addon_optionsArr.find((v) => v.variantId == selectedAddonVariantId);
          if(addonVariantObj){
            var addonItem = {
              'id': selectedAddonVariantId,
              'quantity': selectedAddonVariantQty,
              'properties':{
                '_rec':'addonProduct',
              }
            };
            const addonVariantPreOrder = addonVariantObj.variantPreOrder;
            const addonVariantPreOrderOverride = addonVariantObj.varaintPreOrderOverride;
            const addonVariantIPolicy = addonVariantObj.variantIPolicy ;
            if((addonVariantPreOrder.length > 0 && addonVariantIPolicy == "continue") || (addonVariantPreOrder.length > 0 && addonVariantPreOrderOverride == true)){
              addonItem["properties"]["Pre-Order"] = addonVariantPreOrder;
            }
            productPurchaseList["addonItems"].items.push(addonItem);
          }else{
            console.log('cannot find the selected add-on item');
          }
        } else {
          console.log('addOn-item removed');
        }
    });

    //hide the EOL && 0-stock options
    if(typeof variants_options_arr != "undefined"){
      let $swatchItems = $('.section-main-product .option-selectors .swatch-option-item input');
      const groupedByOption2 = {};
      const groupedByOption1 = {};
      for(const v of variants_options_arr){
        if(v.variant_option2){
          if (!groupedByOption2[v.variant_option2]) {
            groupedByOption2[v.variant_option2] = [];
          }
          groupedByOption2[v.variant_option2].push(v);
        }
        if(v.variant_option1){
          if(!groupedByOption1[v.variant_option1]) {
            groupedByOption1[v.variant_option1] = [];
          }
          groupedByOption1[v.variant_option1].push(v);
        }
      }
      const optionResult = [];
      for(const [option2, items] of Object.entries(groupedByOption2)) {
        //const uniqueOption1 = [...new Set(items.map(v => v.variant_option1))];
        const allUnavailable = items.every(v => v.unavailable === true);
        const allHide = items.every(v => v.hide === true);
        if(allHide){
          optionResult.push(option2);
        }else if(allUnavailable){
          optionResult.push(option2);
        }
      }
      for(const [option1, items] of Object.entries(groupedByOption1)) {
        //const uniqueOption2 = [...new Set(items.map(v => v.variant_option2))];
        const allUnavailable = items.every(v => v.unavailable === true);
        const allHide = items.every(v => v.hide === true);
        if(allHide){
          optionResult.push(option1);
        }else if(allUnavailable){
          optionResult.push(option1);
        }
      }
      let isHide = false;
      for(const item of $swatchItems){
        $(item).closest('.swatch-option-item').removeClass('is-hide');
        if(optionResult.includes($(item).val())) {
          $(item).closest('.swatch-option-item').addClass('is-hide');
          let itemValue = $(item).val();
          let colourValues = $('.pdp-meta-img-text-section #product-info .colour span.value').text()
          ? $('.pdp-meta-img-text-section #product-info .colour span.value').text().split(',').map(item => item.trim())
          : [];
          let newColourValues = "";
          if(colourValues.includes(itemValue)){
            newColourValues = colourValues.filter(c => c != itemValue).join(', ');
          }
          $('.pdp-meta-img-text-section #product-info .colour span.value').text(newColourValues);
          if(item.checked){
            isHide = true;
          }
        }
      }
      if(isHide){
        let allOptionSelectors = $('.section-main-product .option-selectors');
        for(const optionSelector of allOptionSelectors){
          let firstAvailableOption = $(optionSelector).find('.swatch-option-item:not(.is-hide)')[0];
          if(firstAvailableOption) firstAvailableOption.querySelector('input.js-option').click();
        }
      }
    }
    

    function initPhotoSwipeLightbox($container, imgsArr) {
      if (!$container || !imgsArr) return;

      var lightbox = new PhotoSwipeLightbox({
        dataSource: imgsArr,
        pswpModule: PhotoSwipe,
        showHideAnimationType: 'zoom',
        bgOpacity: 1,
        arrowPrevSVG: '<svg class="pswp__icn" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>',
        arrowNextSVG: '<svg class="pswp__icn" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>',
        closeSVG: '<svg class="pswp__icn" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
      });

      lightbox.addFilter('thumbEl', function (thumbEl, data, index) {
        return thumbEl;
      });

      lightbox.addFilter('placeholderSrc', function (placeholderSrc, slide) {
        return placeholderSrc;
      });

      var videoPlugin = new window.PhotoSwipeVideoPlugin(lightbox, {});

      lightbox.init();

      $container.data('lightboxInstance', lightbox);

      $container.find('.mImgLightbox-trigger').each(function (index, el) {
        $(el).on('click', function (e) {
          e.preventDefault();
          lightbox.loadAndOpen(index);
        });
      });

      return lightbox;
    };

    function destroyPhotoSwipeLightbox($container) {
      var lightbox = $container.data('lightboxInstance');
      if (lightbox) {
        lightbox.destroy();
        $container.removeData('lightboxInstance');
      }
    };

    function onQuickbuyPopuploaded($popup, imgsArr){
      if($popup.length) {
        initPhotoSwipeLightbox($popup, imgsArr);
      }
    };

    if($('.product-detail .main-image').length){
      initPhotoSwipeLightbox($('.product-detail .main-image'), mainImgs_arr);
    }

});
$(window).on('load', function() {
    // plp swatch reveal on click
  $('div').on('click','.product-block-options__more-label',function() {
  	let options = $(this).siblings().find('.product-block-options__item');
  	$(this).hide();
  	$(options).css('display', 'inline-block');
  });
    // variant image hover in plp
  $('div').on('mouseover','.product-block-options__inner a span',function() {
  let imgSrc = $(this).attr("data-variant-img");
  $(this).parents('.product-info').siblings(".image-cont").find(".product-block__image--primary img").attr('srcset', imgSrc);
  });

  // plp infinite scroll
  if($('.product-list').hasClass('infinite_scroll')){
  let initCount = 0;

  //$(document).scroll(async function(){
    $(document).on( 'scroll', async function(){
    let offsetBot = window.pageYOffset + window.innerHeight;
    let footerOffset = $('#ajaxScroll').offset().top + $('#ajaxScroll').height();
    if(offsetBot >= footerOffset){
      var pageUrl = $(`#ajaxScroll`).attr('data-nextpage');
      initCount++;
      if( initCount == 1 && pageUrl != '' ){

        $(`[data-section-type="collection-template"],.loadmore`).addClass('ajax-loading');
        if (pageUrl != '') {
          $.ajax({
            url:`${pageUrl}`,
            method:"GET",
            dataType:"html",
            success:function(data){
              var nextPageUrl = $(data).find('#ajaxScroll').attr('data-nextpage');
              var $pCards = $($(data).find('#ajaxScroll').html());

                initCount = 0;
                $('#ajaxScroll').append($pCards).attr('data-nextpage',nextPageUrl);
                $(`[data-section-type="collection-template"],.loadmore`).removeClass('ajax-loading');
                if($('.collection-banner-block')){
                  $(".collection-banner-block").slice(1).remove();
                }


              theme.ProductBlockManager.loadImages($("#ajaxScroll"));
            }
          })
        }
      }
    }
  });
}
});
